import { render } from "./contactData.vue?vue&type=template&id=e0b51bc2&ts=true"
import script from "./contactData.vue?vue&type=script&lang=ts"
export * from "./contactData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__